export default {
  id: 'rsrc.TableDataViewer.onClick',
  matches: {
    objectType: 'rsrc'
  },
  onClick(item, context) {}
};